const MOBILE_SCREEN_WIDTH = 721;
const REGEX = /reverb.*ios|android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
const BUILD_PHRASE_REGEX = /\bbuild (?<version>\d+)/i;
const V2_BUILD_REGEX = /\bbuild\s+(?<version>\d+(?:\.\d+)*)/i;

export default {
  userAgent(): string {
    return navigator.userAgent;
  },

  isMobileBrowser(): boolean {
    return REGEX.test(this.userAgent());
  },

  getClickEvent(): string {
    return this.isMobileBrowser() ? 'touchend' : 'click';
  },

  isMobileScreenWidth(): boolean {
    return window.screen.width < MOBILE_SCREEN_WIDTH;
  },

  buildNumber(): number {
    const number = Number(this.userAgent().match(BUILD_PHRASE_REGEX)?.groups?.version);

    return isNaN(number) ? 0 : number;
  },

  // iOS clients have begun using a new build format string (`2025.12.30.1604` instead of `202512301604`).
  // This new parser (called behind a rollout) is backwards compatible.
  // Once tested, it will replace buildNumber().
  updatedBuildParser(): number {
    const number = Number(this.userAgent().match(V2_BUILD_REGEX)?.groups?.version?.replace(/\./g, ''));

    return isNaN(number) ? 0 : number;
  },
};
